"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpRequest = exports.getProxyDispatcher = exports.isRequestError = exports.RequestError = void 0;
const stream_1 = require("stream");
const undici_1 = require("undici");
const user_agent_1 = require("./user-agent");
class RequestError extends Error {
    constructor(message, config, response) {
        super(message);
        this.isRequestError = true;
        this.name = 'RequestError';
        this.config = config;
        this.response = response;
    }
}
exports.RequestError = RequestError;
const isRequestError = (error) => error instanceof RequestError || (typeof error === 'object' && !!error && error.isRequestError === true);
exports.isRequestError = isRequestError;
const dispatcherCache = new Map();
const getProxyDispatcher = (proxyUrl) => {
    // EnvHttpProxyAgent reads env vars at construction, so never cache it
    if (!proxyUrl) {
        return new undici_1.EnvHttpProxyAgent();
    }
    let dispatcher = dispatcherCache.get(proxyUrl);
    if (!dispatcher) {
        dispatcher = new undici_1.ProxyAgent({ uri: proxyUrl });
        dispatcherCache.set(proxyUrl, dispatcher);
    }
    return dispatcher;
};
exports.getProxyDispatcher = getProxyDispatcher;
const isStream = (body) => typeof body === 'object' && !!body && typeof body.pipe === 'function';
const resolveUrl = (config) => {
    var _a;
    const { url, baseURL, params, paramsSerializer } = config;
    let resolved;
    if (baseURL && url && !String(url).startsWith('http://') && !String(url).startsWith('https://')) {
        // Ensure baseURL ends with / for proper URL resolution
        const base = baseURL.endsWith('/') ? baseURL : baseURL + '/';
        // Remove leading / from url to avoid overriding the base path
        const path = String(url).startsWith('/') ? String(url).slice(1) : String(url);
        resolved = new URL(path, base).toString();
    }
    else {
        resolved = (_a = url !== null && url !== void 0 ? url : baseURL) !== null && _a !== void 0 ? _a : '';
    }
    if (params) {
        const serializer = typeof paramsSerializer === 'function' ? paramsSerializer : paramsSerializer === null || paramsSerializer === void 0 ? void 0 : paramsSerializer.serialize;
        const qs = serializer ? serializer(params) : new URLSearchParams(params).toString();
        const separator = resolved.includes('?') ? '&' : '?';
        resolved = `${resolved}${separator}${qs}`;
    }
    return resolved;
};
const serializeBody = (data, headers) => {
    if (data === undefined) {
        return { body: undefined, headers };
    }
    // form-data (npm package) and similar objects that have .pipe but lack Symbol.asyncIterator.
    // undici requires async-iterable bodies; pipe through a PassThrough to make them compatible.
    if (typeof data.pipe === 'function' && !data[Symbol.asyncIterator]) {
        const passThrough = new stream_1.PassThrough();
        data.pipe(passThrough);
        return { body: passThrough, headers };
    }
    // Proper Node.js Readables / Web ReadableStreams — pass through
    if (isStream(data)) {
        return { body: data, headers };
    }
    // Buffer or string — pass through
    if (typeof data === 'string' || Buffer.isBuffer(data)) {
        return { body: data, headers };
    }
    // Plain object — JSON serialize
    return {
        body: JSON.stringify(data),
        headers: Object.assign({ 'Content-Type': 'application/json' }, headers),
    };
};
const parseResponseHeaders = (headers) => {
    const result = {};
    headers.forEach((value, key) => {
        result[key] = value;
    });
    return result;
};
const httpRequest = (config) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const resolvedUrl = resolveUrl(config);
    const method = ((_a = config.method) !== null && _a !== void 0 ? _a : 'GET').toUpperCase();
    const { body, headers } = serializeBody(config.data, (_b = config.headers) !== null && _b !== void 0 ? _b : {});
    const headersWithUserAgent = Object.assign(Object.assign({}, headers), { 'User-Agent': (0, user_agent_1.getUserAgent)() });
    // Strip null/undefined header values (callers pass null to explicitly unset a header)
    const cleanHeaders = {};
    for (const [k, v] of Object.entries(headersWithUserAgent)) {
        // eslint-disable-next-line no-null/no-null
        if (v !== undefined && v !== null) {
            cleanHeaders[k] = String(v);
        }
    }
    const fetchOptions = {
        method,
        headers: cleanHeaders,
        body,
        dispatcher: config.dispatcher,
        duplex: body !== undefined && isStream(config.data) ? 'half' : undefined,
    };
    if (config.timeout) {
        fetchOptions.signal = AbortSignal.timeout(config.timeout);
    }
    let response;
    try {
        response = yield (0, undici_1.fetch)(resolvedUrl, fetchOptions);
    }
    catch (error) {
        const message = (_e = (_d = (_c = error.cause) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : error.message) !== null && _e !== void 0 ? _e : 'Request failed';
        const requestError = new RequestError(message, config);
        const code = (_f = error.code) !== null && _f !== void 0 ? _f : (_g = error.cause) === null || _g === void 0 ? void 0 : _g.code;
        if (code) {
            ;
            requestError.code = code;
        }
        throw requestError;
    }
    const responseHeaders = parseResponseHeaders(response.headers);
    const mediaType = ((_h = responseHeaders['content-type']) !== null && _h !== void 0 ? _h : '').split(';')[0].trim();
    const rawBody = yield response.text();
    let data = rawBody;
    if (rawBody.length > 0 && (mediaType === 'application/json' || mediaType === 'application/vnd.api+json')) {
        try {
            data = JSON.parse(rawBody);
        }
        catch (_j) {
            // keep as text
        }
    }
    if (!response.ok) {
        const message = `Request failed with status code ${response.status}`;
        throw new RequestError(message, config, {
            data,
            status: response.status,
            statusText: response.statusText,
        });
    }
    return {
        config,
        data,
        headers: responseHeaders,
        status: response.status,
        statusText: response.statusText,
    };
});
exports.httpRequest = httpRequest;
//# sourceMappingURL=request.js.map